import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BUSINESS_URL } from '@/utils';

export interface RegisterUser {
  email: string;
  phoneNumber: string;
  used: boolean;
  active: boolean;
}

export interface VerifyOtpRequest {
  userId: string;
  otp: number;
}

const registerService = createApi({
  reducerPath: 'registerService',
  baseQuery: fetchBaseQuery({ baseUrl: `${API_BUSINESS_URL}` }),
  endpoints: (builder) => ({
    getRegisterUser: builder.query<RegisterUser, { userId: string }>({
      query: ({ userId }) => ({
        url: `/register/${userId}`,
        method: 'GET',
      }),
    }),
    sendOrResendOtp: builder.mutation<void, { userId: string }>({
      query: ({ userId }) => ({
        url: `/user-otp/send-or-resend/${userId}`,
        method: 'POST',
      }),
    }),
    completeRegister: builder.mutation<
      void,
      { userId: string; password: string; confirmPassword: string }
    >({
      query: ({ userId, password, confirmPassword }) => ({
        url: `/register/complete-registration/${userId}`,
        method: 'POST',
        body: { password, confirmPassword },
      }),
    }),
  }),
});

const otpVerifyService = createApi({
  reducerPath: 'otpVerifyService',
  baseQuery: fetchBaseQuery({ baseUrl: `${API_BUSINESS_URL}` }),
  endpoints: (builder) => ({
    verifyOtp: builder.mutation<void, VerifyOtpRequest>({
      query: (data) => ({
        url: '/user-otp/verify',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export default registerService;

export const otpVerifyServiceDefault = otpVerifyService;

export const {
  useGetRegisterUserQuery,
  useSendOrResendOtpMutation,
  useCompleteRegisterMutation,
} = registerService;

export const { useVerifyOtpMutation } = otpVerifyService;
